import topoData from './topo.json';

const countryMap: Record<string, string> = {};

topoData.objects.world.geometries.forEach((geo: { id: string; properties: { name: string } }) => {
  if (geo.id && geo.properties?.name) {
    countryMap[geo.id] = geo.properties.name;
  }
});

export const UNKNOWN_COUNTRY_LABEL = 'Unknown';

export const getCountryName = (code: string): string => countryMap[code] || code;

export const hasCountryFlag = (countryCode: string): boolean => {
  const normalizedCountryCode = countryCode.trim().toUpperCase();

  return (
    normalizedCountryCode !== UNKNOWN_COUNTRY_LABEL && /^[A-Z]{2}$/.test(normalizedCountryCode)
  );
};

// Unicode flag emoji are pairs of regional indicator symbols. This offset maps
// ASCII A-Z character codes to their regional indicator code points.
const REGIONAL_INDICATOR_OFFSET = 127397;

export const getCountryFlagEmoji = (countryCode: string): string => {
  if (!hasCountryFlag(countryCode)) {
    return '';
  }

  const normalizedCountryCode = countryCode.trim().toUpperCase();

  return normalizedCountryCode.replace(/[A-Z]/g, (letter) =>
    String.fromCodePoint(REGIONAL_INDICATOR_OFFSET + letter.charCodeAt(0))
  );
};

